import { useFeatureFlag } from '@shape/feature-flag';
import { useLocation } from 'react-router-dom';
import LangflowChat from '../../ui/LangFlowChat/LangflowChat';

const ChatWidget = () => {
  const isEnabled = useFeatureFlag('feat-langflow');
  const location = useLocation();

  if (location.pathname === '/login' || !isEnabled) {
    return null;
  }

  return <LangflowChat />;
};

export default ChatWidget;
